module.exports = __webpack_public_path__ + "img/visa.5e290704.svg";